'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _icon = require('@alicd/next/lib/icon');

var _icon2 = _interopRequireDefault(_icon);

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames3 = require('classnames');

var _classnames4 = _interopRequireDefault(_classnames3);

var _lib = require('@alicd/next/lib/_components/@alicd/next-mixin-ui-state/lib');

var _lib2 = _interopRequireDefault(_lib);

var _lib3 = require('@alicd/next/lib/_components/@alicd/next-util/lib');

var _util = require('./util');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/** Checkbox */
var Checkbox = function (_UIState) {
    (0, _inherits3.default)(Checkbox, _UIState);

    function Checkbox(props, context) {
        (0, _classCallCheck3.default)(this, Checkbox);

        var _this = (0, _possibleConstructorReturn3.default)(this, (Checkbox.__proto__ || (0, _getPrototypeOf2.default)(Checkbox)).call(this, props));

        var checked = void 0,
            indeterminate = void 0,
            disabled = void 0;
        if (context.__group__) {
            indeterminate = false;
            checked = (0, _util.isChecked)(context.selectedValue, props.value);
            disabled = context.disabled;
        } else {
            if ('checked' in props) {
                checked = props.checked;
            } else {
                checked = props.defaultChecked;
            }

            if ('indeterminate' in props) {
                indeterminate = props.indeterminate;
            } else {
                indeterminate = props.defaultIndeterminate;
            }
        }

        _this.state = {
            checked: checked,
            indeterminate: indeterminate,
            disabled: disabled
        };

        _this.onChange = _this.onChange.bind(_this);
        return _this;
    }

    (0, _createClass3.default)(Checkbox, [{
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps, nextContext) {
            if (nextContext.__group__) {
                var selectedValue = nextContext.selectedValue,
                    disabled = nextContext.disabled;

                if ('selectedValue' in nextContext && 'disabled' in nextContext) {
                    this.setState({
                        checked: (0, _util.isChecked)(selectedValue, nextProps.value),
                        disabled: disabled
                    });
                } else if ('selectedValue' in nextContext) {
                    this.setState({
                        checked: (0, _util.isChecked)(selectedValue, nextProps.value)
                    });
                } else if ('disabled' in nextContext) {
                    this.setState({
                        disabled: disabled
                    });
                }
            } else {
                if ('checked' in nextProps) {
                    this.setState({
                        checked: nextProps.checked
                    });
                }
                if ('indeterminate' in nextProps) {
                    this.setState({
                        indeterminate: nextProps.indeterminate
                    });
                }
            }
        }
    }, {
        key: 'onChange',
        value: function onChange(e) {
            var checked = e.target.checked;
            var value = this.props.value;

            if (this.state.disabled || this.props.disabled) {
                return;
            }

            if (this.context.__group__) {
                this.context.onChange(value, e);
            } else {
                if (!('checked' in this.props)) {
                    this.setState({
                        checked: checked
                    });
                }

                if (!('indeterminate' in this.props)) {
                    this.setState({
                        indeterminate: false
                    });
                }
                this.props.onChange(checked, e);
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _classnames;

            var _props = this.props,
                className = _props.className,
                children = _props.children,
                defaultChecked = _props.defaultChecked,
                style = _props.style,
                others = (0, _objectWithoutProperties3.default)(_props, ['className', 'children', 'defaultChecked', 'style']);

            var checked = this.state.checked;
            var disabled = this.state.disabled || this.props.disabled;
            var indeterminate = this.state.indeterminate;
            var newOthers = (0, _lib3.pickAttrs)(others);
            var prefix = this.context.prefix || this.props.prefix;

            var checkedAttr = {};
            if ('checked' in this.props) {
                checkedAttr = {
                    checked: checked
                };
            } else if ('defaultChecked' in this.props) {
                checkedAttr = {
                    defaultChecked: defaultChecked
                };
            }
            var input = _react2.default.createElement('input', (0, _extends3.default)({
                type: 'checkbox'
            }, newOthers, checkedAttr, {
                onChange: this.onChange,
                'aria-checked': checked
            }));

            var child = this.getStateElement(input);
            var cls = (0, _classnames4.default)((_classnames = {}, (0, _defineProperty3.default)(_classnames, prefix + 'checkbox', true), (0, _defineProperty3.default)(_classnames, className, !!className), (0, _defineProperty3.default)(_classnames, 'checked', checked), (0, _defineProperty3.default)(_classnames, 'disabled', disabled), (0, _defineProperty3.default)(_classnames, 'indeterminate', indeterminate), (0, _defineProperty3.default)(_classnames, this.getStateClassName(), true), _classnames));
            var childrenCls = (0, _classnames4.default)((0, _defineProperty3.default)({}, prefix + 'checkbox-label', !!children));
            var type = indeterminate ? 'semi-select' : 'select';

            return children ? _react2.default.createElement(
                'label',
                { htmlFor: this.props.id },
                _react2.default.createElement(
                    'span',
                    { className: cls, style: style },
                    _react2.default.createElement(
                        'span',
                        { className: prefix + 'checkbox-inner' },
                        _react2.default.createElement(_icon2.default, { type: type, size: 'xs', className: indeterminate ? 'zoomIn' : '' })
                    ),
                    child
                ),
                _react2.default.createElement(
                    'span',
                    { className: childrenCls },
                    children
                )
            ) : _react2.default.createElement(
                'label',
                { className: cls, style: style },
                _react2.default.createElement(
                    'span',
                    { className: prefix + 'checkbox-inner' },
                    _react2.default.createElement(_icon2.default, { type: type, size: 'xs', className: indeterminate ? 'zoomIn' : '' })
                ),
                child
            );
        }
    }]);
    return Checkbox;
}(_lib2.default);

Checkbox.displayName = 'Checkbox';
Checkbox.propTypes = {
    /**
     * 样式类名的品牌前缀
     */
    prefix: _propTypes2.default.string,
    /**
     * 自定义类名
     */
    className: _propTypes2.default.string,
    /**
     * 自定义内敛样式
     */
    style: _propTypes2.default.object,
    /**
     * 选中状态
     */
    checked: _propTypes2.default.bool,
    /**
     * 默认选中状态
     */
    defaultChecked: _propTypes2.default.bool,
    /**
     * 禁用
     */
    disabled: _propTypes2.default.bool,
    /**
     * Checkbox 的中间状态，只会影响到 Checkbox 的样式，并不影响其 checked 属性
     */
    indeterminate: _propTypes2.default.bool,
    /**
     *  Checkbox 的默认中间态，只会影响到 Checkbox 的样式，并不影响其 checked 属性
     */
    defaultIndeterminate: _propTypes2.default.bool,
    /**
     * 状态变化时触发的事件
     * @param {Boolean} checked 是否选中
     * @param {Event} e Dom 事件对象
     */
    onChange: _propTypes2.default.func
};
Checkbox.defaultProps = {
    defaultChecked: false,
    defaultIndeterminate: false,
    onChange: function onChange() {},
    prefix: 'next-'
};
Checkbox.contextTypes = {
    onChange: _propTypes2.default.func,
    __group__: _propTypes2.default.bool,
    selectedValue: _propTypes2.default.array,
    disabled: _propTypes2.default.bool,
    prefix: _propTypes2.default.string
};
exports.default = Checkbox;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@alicd_crui-checkbox@0.0.1@@alicd/crui-checkbox/lib/checkbox.js
// module id = 261
// module chunks = 0